import { EnvFile } from './schema';

export const EXPOSED_ENV_KEYS: Record<keyof EnvFile, string> = {
  SERVER_URI: 'VITE_SERVER_URI',
  CLIENT_URI: 'VITE_CLIENT_URI',
  UPS_URI: 'VITE_UPS_URI',
  WP_ADMIN_URI: 'VITE_WP_ADMIN_URI',
  HOST_WS: 'VITE_HOST_WS',
  PRODUCT_CREATION_ALLOWED: 'VITE_PRODUCT_CREATION_ALLOWED',
  CACHE_EXPIRATION: 'VITE_CACHE_EXPIRATION',
  RESEND_EMAIL_CODE_COOL_DOWN: 'VITE_RESEND_EMAIL_CODE_COOL_DOWN',
  IS_DEV: 'VITE_IS_DEV',
  I18N_DEBUG: 'VITE_I18N_DEBUG',

  // Logger
  LOG_LEVEL: 'VITE_LOG_LEVEL',
  LOG_GROUP_NAME: 'VITE_LOG_GROUP_NAME',
  LOG_STREAM_NAME: 'VITE_LOG_STREAM_NAME',
  CLOUDWATCH_LOGGER_ENABLED: 'VITE_CLOUDWATCH_LOGGER_ENABLED',

  // AWS
  CLOUDWATCH_ACCESS_KEY: 'VITE_CLOUDWATCH_ACCESS_KEY',
  CLOUDWATCH_SECRET_ACCESS_KEY: 'VITE_CLOUDWATCH_SECRET_ACCESS_KEY',
  CLOUDWATCH_REGION: 'VITE_CLOUDWATCH_REGION',
} as const;
